import { useEffect, useState, useRef } from 'react'
import { Link, Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import components from './components/languages/index'
import Home from './components/Home'
import langPairs from "./langpairs.json"
import Felhasznalasi from './components/Felhasznalasi'
import Adatvedelem from './components/Adatvedelem'
import logo from "./assets/online-fordito.svg"


import './App.css'



function App() {


  const [text, setText] = useState("")
  const [output, setOutput] = useState("")
  const [langs, setLangs] = useState([])


  const handleText = (input) => {

    setText(input.target.value)

  }


  // Set up langs state as selected by user

  const handleSource = (input) => {

    const langTemp = [...langs]
    langTemp[0] = input.target.value
    setLangs(langTemp)


  }

  const handleTarget = (input) => {

    const langTemp = [...langs]
    langTemp[1] = input.target.value
    setLangs(langTemp)


  }

  //  Set up location based on langs


  //  const navigate = useNavigate()

  //  useEffect(() => {

  //    const item = langPairs.find((item) => item.source === langs[0] && item.target === langs[1])

  //    if (item) {
  //    navigate(item.url)
  //    window.scrollTo(0, 0);
  //   setOutput("")
  //    }


  //     }, [langs])


  // Set up langs based on location 

  const locationCurrent = useLocation();

  useEffect(() => {


    langPairs.find((item) => {
      if (item.url === locationCurrent.pathname) {

        setLangs([item.source, item.target])
        window.scrollTo(0, 0);
        setText("")
        setOutput("")
      }
    });


  }, [locationCurrent.pathname]);


  // Call API 


  const handleTranslate = () => {
    if (!langs[1] || !text) return;

    // --- your existing characterCount / lastDate localStorage code stays here ---

    const fetchData = async () => {
      try {
        const { key } = await (await fetch('/auth.php')).json();

        const url = 'https://deep-translate1.p.rapidapi.com/language/translate/v2';
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            'X-RapidAPI-Key': key,
            'X-RapidAPI-Host': 'deep-translate1.p.rapidapi.com',
          },
          body: JSON.stringify({
            q: text,            // ← was { text }; must be a plain string
            source: langs[0],
            target: langs[1],
          }),
        });

        if (!response.ok) {
          setOutput('A fordítás most nem érhető el.');
          return;
        }

        const result = await response.json();
        const t = result?.data?.translations?.translatedText; // usually a string
        const translated = Array.isArray(t) ? t[0] : t;        // ← handle both, no blind [0]

        setOutput(translated && translated.length ? translated : 'Nincs fordítás.');
      } catch (error) {
        console.error(error);
        setOutput('Hiba történt a fordítás során.');
      }
    };

    fetchData();
  };


  // Clearing up output

  useEffect(() => {

    console.log(text)
    console.log(langs)
    console.log(output)

    setOutput("")
    console.log(location.pathname)


  }, [text, langs, location])


  // Change source and target language

  const handleSwap = () => {

    if (langs[0] !== "felismer") {
      const langsTemp = [langs[1], langs[0]]
      setLangs(langsTemp)
    }

  }


  // Detect language 

  useEffect(() => {
    if (langs[0] === "felismer" && text.length > 5 || langs[0] === undefined && text.length > 5 || langs.length === 0 && text.length > 5) {
      const url = 'https://deep-translate1.p.rapidapi.com/language/translate/v2/detect';
      const options = {
        method: 'POST',
        headers: {
          'X-RapidAPI-Key': "b891b79e7amsha28c1ff94dca289p147fa1jsnb2de05da701e",
          'X-RapidAPI-Host': 'deep-translate1.p.rapidapi.com'
        },
        body: JSON.stringify({ q: text })
      };

      const fetchData = async () => {
        try {
          const response = await fetch(url, options);
          const result = await response.json();
          console.log(result);

          const langTemp = [result.data.detections[0].language, langs[1]]
          setLangs(langTemp)

        } catch (error) {
          console.error(error);
        }
      };

      fetchData();
    }
  }, [langs, text]);


  return (
    <>
      <nav>
        <div className='logo' ><Link to="/"><img src={logo}></img></Link>

        </div>

        <div >
          <p className='howitworks'>Hogy működik?</p>
          <div className='showhowitworks'>

            <p>Online fordítónk működése rendkívül egyszerű. Csak írd vagy másold be a fordítandó szöveget, válaszd ki a forrás és célnyelvet, majd kattints a 'Fordítás' gombra.</p>
            <p>A fordítás irányát felcserélheted a középen található irányváltó gombbal.</p>
          </div>

        </div>




      </nav>

      <Routes>
        <Route path="/" element={<Home output={output} handleText={handleText} handleTarget={handleTarget} handleSource={handleSource} langs={langs} handleSwap={handleSwap} langPairs={langPairs} handleTranslate={handleTranslate} text={text} />}></Route>
        <Route path="/felhasznalasi-feltetelek" element={<Felhasznalasi />}> </Route>
        <Route path="/adatvedelmi-nyilatkozat" element={<Adatvedelem />}></Route>

        {langPairs.map((lang) => {
          const match = components.find((item) => item.name === lang.component);
          if (!match) return null;
          const Component = match.component;
          return (
            <Route
              key={lang.url}
              path={lang.url}
              element={<Component handleText={handleText} output={output} handleTarget={handleTarget} handleSource={handleSource} langs={langs} handleSwap={handleSwap} handleTranslate={handleTranslate} text={text} />}
            />
          );
        })}



      </Routes>

      <footer className='links'>
        <h2>További fordítóink</h2>
        <ul>
          {langPairs
            .filter(item => !item.name.startsWith("Magyar")) // Filter out items that start with "Magyar"
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(item => (
              <li key={item.url}>
                <Link to={item.url}>{item.name}</Link>
              </li>
            ))}
        </ul>




      </footer>
      <div className='bottomfooter'>
        <Link to="/rolunk">Rólunk</Link>
        <Link to="/felhasznalasi-feltetelek">Felhasználási feltételek</Link>
        <Link to="/adatvedelmi-nyilatkozat">Adatvédelmi nyilatkozat</Link>
      </div>

    </>
  )
}

export default App
